export const HOME_HEADER_ANGLE_IN_DEGREES = -8.6
export const HOME_HEADER_ANGLE_IN_RADIANS = HOME_HEADER_ANGLE_IN_DEGREES * Math.PI / 180
